<template>
  <div class="overflow-x-auto scrollbar-hidden" v-if="dataArray.length>0">
      <DatatableProfile :data-array="dataArray" :data-array-table="dataArrayTable" :router-name="'member'" />
  </div>
</template>

<script>
import DatatableProfile from "@/components/datatable/datatableProfile.vue"
import { defineComponent, reactive, ref, onMounted } from "vue"
import Swal from "sweetalert2";
import { useStore } from 'vuex'
import axios from "axios"
var md5 = require('md5');

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
    denyButton: "btn btn-danger ทขๅ",
  },
  buttonsStyling: false,
});
export default defineComponent({
    props:{
        dataArray:{
            type: Array
        }
    },
    components:{
        DatatableProfile
    },
    setup(props,{emit}){
        var customNameMutator = (value, data, type, params, component) => {
            return `${data.title?data.title:""}${data.name?data.name:""} ${data.surname?data.surname:""} `
        }
        var customProblemMutator = (value, data, type, params, component) => {
            return {
                "housing": data.prob_housing,
                "health": data.prob_health,
                "occupation": data.prob_occupation,
                "education": data.prob_education,
                "accessibility": data.prob_accessibility,
                "family": data.prob_family,
                "violence": data.prob_violence,
                "human_trafficking": data.prob_human_trafficking,
                "others": data.prob_others
            }
        }
          var customLinkingSystemMutator = (value, data, type, params, component) => {
      return  data.linking_system
    };
        const store = useStore()
        const dataArrayTable = reactive([
            {title:"สมาชิก", field:"full_name",minWidth: 150, resizable:true, formatter:"textarea", mutator: customNameMutator},
            {title:"สภาพปัญหา", field:"problems", minWidth: 400, mutator: customProblemMutator, variableHeight:true, headerSort: false,
                formatter:function(cell, formatterParams){
                    var value = cell.getValue();
                    let res = `<div class="flex flex-wrap"><button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.housing > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">ที่อยู่อาศัย</span>\
                                <span class="img-icon map-pin-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.health > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">สุขภาพอนามัย</span>\
                                <span class="img-icon heart-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.education > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">การศึกษา</span>\
                                <span class="img-icon book-open-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.occupation > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">การมีงานทำและมีรายได้</span>\
                                <span class="img-icon dollar-sign-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.family > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">ครอบครัว</span>\
                                <span class="img-icon home-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.violence > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">ความรุนแรงในครอบครัว/สังคม</span>\
                                <span class="img-icon glove-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.human_trafficking > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">การเป็นผู้เสียหายจากการค้ามนุษย์</span>\
                                <span class="img-icon payment-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.accessibility > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">การเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม</span>\
                                <span class="img-icon card-icon"></span>\
                            </button>\
                            <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.others > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">สภาพปัญหาสังคมอื่นๆ</span>\
                                <span class="img-icon cloud-lightning-icon"></span>\
                            </button></div>`
                    return res
                }
            },{
  title: "การเชื่อมโยงกับระบบอื่น",
  field: "linking_system",
  width: 250,
  mutator: customLinkingSystemMutator, // อย่าลืมเช็คใน mutator ด้วยว่าแปลงข้อมูลถูกต้องไหม
  variableHeight: true,
  formatter: function(cell, formatterParams) {
    let res = ""; // เปลี่ยนจาก null เป็น "" เพื่อป้องกันคำว่า 'null' ปรากฏใน HTML
    let value = cell.getValue();

    if (Array.isArray(value) && value.length > 0) {
      res += '<div class="flex flex-wrap">';
      
      value.forEach((item) => {
        // ตรวจสอบว่า item มีข้อมูล และดึงค่า system ออกมา
        // รองรับทั้งแบบใหม่ {system: "CSG"} และแบบเก่า "CSG" (เผื่อข้อมูลเก่าค้างในระบบ)
        const systemValue = (typeof item === 'object' && item !== null) ? item.system : item;
        const updatedAt = (item && item.updated_at) ? item.updated_at : "";

        if (systemValue) {
          let tooltipText = "";
          const systemInfo = systemMap[systemValue];

          if (systemInfo) {
            tooltipText = systemInfo.tooltipText;
            // โชว์วันที่อัปเดตใน Tooltip ด้วย สามารถต่อ String
            if (updatedAt) {
              tooltipText += ` (ข้อมูล ณ วันที่: ${updatedAt})`;
            }
          } else {
            tooltipText = "ไม่พบข้อมูลระบบ";
          }

          res += `<button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-0 mb-1'>
                    <span class="t-tooltip-text">${tooltipText}</span>
                    <span class=""><img src="${require("@/assets/images/logo/" + systemValue + ".png")}"></span>
                  </button>`;
        }
      });
      
      res += '</div>';
    }
    return res;
  },
},
//       {
//         title: "การเชื่อมโยงกับระบบอื่น",
//         field: "linking_system",
//         width: 250,
//         mutator: customLinkingSystemMutator,
//         variableHeight: true,
//         formatter: function(cell, formatterParams) {
//           let res = null;
//         let value = cell.getValue();
//           if (Array.isArray(value) && value.length > 0) {
//             res += '<div class="flex flex-wrap">';
//             value.forEach((item) => {
//               if (item ) {
//                 const systemValue = item;
//                 let tooltipText = "";
//                 const systemInfo = systemMap[systemValue];
// if (systemInfo) {
//     tooltipText = systemInfo.tooltipText;
// } else {
//     tooltipText = "ไม่พบข้อมูลระบบ"; 
// }
//                 if (tooltipText) {
//                   res += `<button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-0 mb-1'>\
//                             <span class="t-tooltip-text">${tooltipText}</span>\
//                             <span class=""><img src="${require("@/assets/images/logo/"+systemValue+".png")}"></span>\
//                         </button>`;
//                 }
//               }
//             });
//         res += '</div>';
//           }
//           return res;
//         },
//       },
            // {title:"สถานะ", field:"status", hozAlign:"center", minWidth: 200, resizable:true,
            //     formatter:function(cell, formatterParams){
            //         if(cell.getValue() == "created"){
            //             return "รอตรวจสอบ"
            //         }
            //         else{
            //             return "รออนุมัติ"
            //         }
            //     }
            // },
            //     {title: "การดำเนินการ", field:"action", minWidth: 150, width: 150, formatter:function(cell, formatterParams){
            //         const a = cash(`<div class="flex lg:justify-center items-center">
            //                 <a class="flex items-center text-theme-24" href="javascript:;">
            //                     <i data-feather="trash-2" class="w-4 h-4 mr-1"></i> ลบข้อมูลสมาชิก
            //                 </a>
            //             </div>`)
            //         //on click action
            //         cash(a).on('click', function(e) {
            //             e.stopPropagation();
            //             swalCustom.fire({
            //                 html:`<div>ต้องการลบข้อมูล</div><div>${cell.getData().title}${cell.getData().name} ${cell.getData().surname}?</div>`,
            //                 icon:"warning",
            //                 showCancelButton: true,
            //                 reverseButtons: true,
            //                 confirmButtonText: 'ตกลง',
            //                 cancelButtonText: 'ยกเลิก',
            //                 showDenyButton: true,
            //                 showConfirmButton: false,
            //                 denyButtonText: "ลบ",
            //             }).then((result)=>{
            //                 if(result.isDenied){
            //                     const token = store.getters["userAuth/getToken"];
            //                     const config = {
            //                         url: `${process.env.VUE_APP_BASE_API}member/${cell.getData()._id}`,
            //                         method: "PUT",
            //                         headers:{
            //                             Authorization: `Bearer ${token}`,
            //                             "Content-Type": `application/json; charset=utf-8`,
            //                         },
            //                         data:{
            //                             update:{
            //                                 "status": "removed",
            //                                 "msoid": md5(Date.now())
            //                             }
            //                         }
            //                     };
            //                     axios(config)
            //                     .then(() => {
            //                         swalCustom.fire({
            //                             text:"สำเร็จ",
            //                             icon: 'success',
            //                             timer: 3000,
            //                             confirmButtonText: "ปิด",
            //                         }).then(() => {
            //                             emit('update-table')
            //                         });
            //                     })
            //                     .catch((error) => {
            //                         swalCustom.fire({
            //                             text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            //                             icon: "warning",
            //                             //timer: 3000, //timeOut for auto-close
            //                             confirmButtonText: "ปิด",
            //                         });
            //                         console.log(error);
            //                     });
            //                 }
            //             })
            //         })
            //         return a[0]
            //     }
            // }
            // {title:"จำนวนสมาชิก", field:"count", hozAlign:"center", resizable:false, minWidth: 200},
        ])
        return {
            dataArrayTable
        }
    }
})
</script>

<style>

</style>